import { isNil, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicOrderItemAttribute } from './public-order-item-attribute';
import { ProductType } from '../../shared/enums';
import { OrderItemRefundSummary } from '../../shared/models';
import { PublicOrderItemComponentGroup } from './public-order-item-component-group';

export class PublicOrderItem {
  public constructor(
    private readonly data: {
      name: string;
      subName?: Nillable<string>;
      slug?: Nillable<string>;
      type: ProductType;
      quantity: number;
      unitPrice: number;
      price: number;
      featuredFile?: Nillable<Multimedia>;
      attributes: PublicOrderItemAttribute[];
      componentGroups: PublicOrderItemComponentGroup[];
      refundSummary?: Nillable<OrderItemRefundSummary>;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }
  public get subName(): Nillable<string> {
    return this.data.subName;
  }
  public get slug(): Nillable<string> {
    return this.data.slug;
  }
  public get type(): ProductType {
    return this.data.type;
  }
  public get quantity(): number {
    return this.data.quantity;
  }
  public get unitPrice(): number {
    return this.data.unitPrice;
  }
  public get price(): number {
    return this.data.price;
  }
  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }
  public get attributes(): PublicOrderItemAttribute[] {
    return this.data.attributes;
  }
  public get componentGroups(): PublicOrderItemComponentGroup[] {
    return this.data.componentGroups;
  }
  public get canShowNameAsLink(): boolean {
    return !isNil(this.data.slug) && !isNil(this.data.type);
  }
  public get refundSummary(): Nillable<OrderItemRefundSummary> {
    return this.data.refundSummary;
  }
}
